<template>
  <div style="padding:0 20px">
    <treeRender
      :hover-node="hoverNode"
      :allow-drop="allowDrop"
      :grag-item="gragItem"
      :could-grag="couldGrag"
      :drop-fun="dropFun"
      :drag-fun="dragFun"
      :could-checkout="couldCheckout"
      :list="treeDataOwn"
      :level="0"
      :add-new-one="addNewOne"
      :check-box-change="checkBoxChange"
      :edit-one="editOne"
      :start-stop-use="startStopUse"
      :could-select="couldSelect"
      :could-edit="couldEdit"
      :selected-change="selectedChange"
      :could-fold-all="couldFoldAll"
      :fold-all-fun="foldAllFun"
      :could-unfold-all="couldUnfoldAll"
      :dragend-fun="dragendFun"
    />
  </div>
</template>
<script>
/**  
 * 组件不会监听treeData的变化，如果需要数据的更新需要，如果需要更新，需要将组件销毁并从新实例
 * 
 * @param { props:Array } treeData - 树形结构
 * 详情看代码
 * @param { props:Bool } couldCheckout - 是否支持勾选
 * @param { props:Bool } couldEdit - 是否支持编辑
 * @param { props:Bool } couldSelect - 是否支持选择
 * 
 * @emit {  } addNewOne 输出当前节点和一个回调 对数数据进行原位修改
 * @emit {  } editOne 输出当前节点和父节点 当前节点 是否是删除该节点 回调 对数数据进行原位修改
 * @emit { } startStopUse 同上
**/
    import treeRender from './components/treeRender.vue'
    import { addExpendAndClone,acquirebeforeAll, acquireAfterAll,diffTree } from './utils'
    export default {
        components: {
            treeRender
        },
        props:{
            treeData:{
                type:Array,
                default:() => []
            },
            couldCheckout: {
                type: Boolean,
                default: false
            },
            couldEdit: {
                type: Boolean,
                default: false
            },
            couldSelect: {
                type: Boolean,
                default: false
            },
            couldFoldAll: {
                type: Boolean,
                default: true
            },
            couldUnfoldAll: {
                type: Boolean,
                default: true
            },
            couldGrag: {
                type: Boolean,
                default: true
            }
        },
        data (){
            this.nodeBeforeAll= {}
            this.nodeAfterAll = {}
            this.selectedItem = null
            this.dropMoveItem = null
            this.sourceTree = null
            this.defaultVals =[]
            this._select_children = []
            this.select_expend = null
            return {
                gragItem: null,
                hoverNode: null,
                treeDataOwn: [],
            }
        },
        watch: {
            treeData (value) {
                this.treeDataOwn = diffTree(value,this.treeDataOwn,{defaultVals:this.defaultVals})
                this.sourceTree = this.treeData
                if(this.couldCheckout) {
                    this.nodeBeforeAll = acquirebeforeAll(this.treeDataOwn[0].items)
                    this.nodeAfterAll = acquireAfterAll(this.treeDataOwn[0].items)
                }
            }
        },
        mounted () {
           this.defaultVals = [
               {
                    key:'expand',
                    val: true
               }
           ]
           if(this.couldSelect) {
               this.defaultVals.push({
                   key:'selected',
                   val:false
               })
           }
           if(this.couldCheckout) {
               this.defaultVals.push({
                   key:'checkout',
                   val:false
               })
           }
           // 数据初始化
          this.treeDataOwn = addExpendAndClone(this.treeData,this.defaultVals)
          this.sourceTree = this.treeData
          if(this.couldCheckout) {
              this.nodeBeforeAll = acquirebeforeAll(this.treeDataOwn[0].items)
              this.nodeAfterAll = acquireAfterAll(this.treeDataOwn[0].items)
          }
        },
        methods: {
            clearMarkNode () {
              if(this._select_children) { // 清楚之前选中的样式
                        this._select_children.forEach(node => {
                            node.style = ''
                        });
                       this._select_children = []
                }
             },
            // 增加新的item
            addNewOne (data) {
                this.$emit('addNewOne',data)
            },
            // 编辑item
            editOne (level,parent,child) {
                this.$emit('editOne',level,parent,child,false)
            },
            // 删除item
            startStopUse (level,parent,child) {
                this.$emit('startStop',level,parent,child,true)
            },
            // chekcoutbox勾选的
            checkBoxChange (data) { // 勾选
                if(data.checkout) {
                  const nodeBeforeArr = this.nodeBeforeAll[data.auth_key] ||[]
                  const nodeAfterArr = this.nodeAfterAll[data.auth_key] || []
                  if(nodeBeforeArr.length>0) {
                      nodeBeforeArr.forEach(item => {
                          item.checkout = true
                      })
                  }
                  if(nodeAfterArr.length>0) {
                      nodeAfterArr.forEach(item => {
                          item.checkout = true
                      })
                  }
                } else {
                    const nodeAfterArr = this.nodeAfterAll[data.auth_key] || []
                    if(nodeAfterArr.length>0) {
                      nodeAfterArr.forEach(item => {
                          item.checkout = false
                      })
                  }
                }
            },
            // 选中
            selectedChange (data) { // 选中
                if(this.selectedItem&&data.id===this.selectedItem.id) {
                    return
                }
                data.selected = true
                if(this.selectedItem) {
                    this.selectedItem.selected = false
                }
                this.selectedItem = data
                this.$emit('selectedChange',this.selectedItem)
            },
            // 全部折叠/全部展开
            foldAllFun (value) {
                this.treeDataOwn.reduce( function _reducer (total,item) {
                    item.expand = value
                    if(item.items&&item.items.length) {
                        item.items.reduce(_reducer,[])
                    }
                    return total
                },[])
            },
            // 拖拽
            dragFun (data) {
                this.gragItem = data
                this.select_expend = data.expand
                data.expand = false
            },
            dropFun (data,type) {
                const { id } = this.gragItem // id
                if(id===data.id) {
                    this.$Message.warning('节点相同') 
                } else {
                    let parent_id = null
                    let prev_id = null
                    if(type==='child') {
                        parent_id = data.app_token?0:data.id
                        prev_id = 0
                    } else {
                        parent_id = data.app_token?0:data.parent_id
                        prev_id = data.id
                    }
                     this.$emit('gragOk',{id,parent_id,prev_id})                  
                }
            },
            dragendFun () {
              requestAnimationFrame(() => {
                 this.gragItem.expand = this.select_expend
                 this.gragItem = null
                 this.hoverNode = null
                 if(this.dropMoveItem) {
                     this.clearMarkNode()
                     this.dropMoveItem.style = ''
                     this.dropMoveItem.children[0].style = ''
                 }
                 this.dropMoveItem = null
              })
            },
            allowDrop ([e],treeNode,tag){
                // 相同的dome节点不更新信息
                if(this.dropMoveItem===e.toElement||(this.hoverNode===treeNode&&this.hoverNode._tag===tag)) {
                    return 
                }
                /* ------- treeNode未发生变化但是鼠标悬停位置发生变化时 ------- */
                this.clearMarkNode()
                if(this.hoverNode===treeNode) { // 为自己选项着色
                    this.hoverNode._tag = tag
                    if(tag!=='parent') {
                        e.toElement.style = 'border: 1px solid rgba(45,140,240,1);color: rgba(45,140,240,1);'
                        this._select_children.push(e.toElement)
                    }
                    return
                }
                /* ------- treeNode发生变化时 -------- */
                let domNode = null
                const drageNodeType = e.toElement.getAttribute("drageNodeType")
                if(drageNodeType==='parent') {
                    domNode = e.toElement.parentNode
                } else if(drageNodeType==='child') {
                    domNode = e.toElement.parentNode.parentNode                  
                }
                if(this.dropMoveItem&&this.dropMoveItem.style) {
                    this.dropMoveItem.style = ''
                    this.dropMoveItem.children[0].style = ''
                }
                if(!drageNodeType||drageNodeType==='del') { // 当该树节点的
                    return 
                }
                if(this.hoverNode) {
                    delete this.hoverNode._tag
                    delete this.hoverNode._select_children
                }
                treeNode._tag = tag
                this.hoverNode = treeNode
                this.dropMoveItem = domNode
                this.dropMoveItem.children[0].style = 'color:rgb(30,144,255)'     
            }
        },
    }
</script>
